import { render, staticRenderFns } from "./InteractionItem.vue?vue&type=template&id=295af3cf&scoped=true"
import script from "./InteractionItem.vue?vue&type=script&lang=js"
export * from "./InteractionItem.vue?vue&type=script&lang=js"
import style0 from "./InteractionItem.vue?vue&type=style&index=0&id=295af3cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295af3cf",
  null
  
)

export default component.exports